<template>
  <b-card>
    <b-tabs
      :vertical="window.width >= 407 ? false : true"
      nav-wrapper-class="w-100"
    >
      <b-tab title="صادرات 8008" active>
        <list-table
          url="get-depositeList/Saderat"
          title="گزارش صورتحساب صادرات"
          :fields="fields"
          :params="params"
        ></list-table>
      </b-tab>
      <b-tab title="صادرات 4000">
        <list-table
          url="get-depositeList/Saderat4000"
          title="گزارش صورتحساب صادرات"
          :fields="fields"
          :params="params"
        ></list-table>
      </b-tab>
      <b-tab title="صادرات 8009">
        <list-table
          url="get-depositeList/Saderat8009"
          title="گزارش صورتحساب صادرات"
          :fields="fields"
          :params="params"
        ></list-table>
      </b-tab>
      <b-tab title="صادرات 6004">
        <list-table
          url="get-depositeList/Saderat6004"
          title="گزارش صورتحساب صادرات"
          :fields="fields"
          :params="params"
        ></list-table>
      </b-tab>
      <b-tab title="ملی">
        <list-table
          url="get-depositeList/Melli"
          title="گزارش صورتحساب ملی"
          :fields="fields"
          :params="params"
        ></list-table>
      </b-tab>
      <b-tab title="سامان ۲">
        <list-table
          url="get-depositeList/Saman2"
          title="گزارش صورتحساب سامان ۲"
          :fields="fields"
          :params="params"
        ></list-table>
      </b-tab>
      <b-tab title="سامان ۱">
        <list-table
          url="get-depositeList/Saman"
          title="گزارش صورتحساب سامان ۱"
          :fields="fields"
          :params="params"
        ></list-table>
      </b-tab>
    </b-tabs>
  </b-card>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";
export default {
  name: "depositStatement",
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      merchants: [],
      url: "inandout?typeofpayment=2",
      params: [
        {
          label: "تاریخ",
          field: "date",
          type: "date-picker",
          value: persianDate.getDate(new Date()),
        },
      ],
      fields: [
        {
          key: "referenceNumber",
          label: "کد رهگیری",
        },
        {
          key: "date",
          label: "تاریخ",
          formatter(value, key, item) {
            return persianDate.getDate(value);
          },
        },
        {
          key: "time",
          label: "ساعت",
          formatter(value, key, item) {
            //value = new Date(value);
            return persianDate.getTime(item.date);
          },
        },
        {
          key: "transferAmount",
          label: "مبلغ",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "description",
          label: "توضیحات",
        },
        {
          key: "balance",
          label: "موجودی",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "گزارش  صورتحساب" }]);
  },
  components: {
    "list-table": TableShowData,
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
};
</script>